import { createContext, useContext } from "react";

const AlertContext = createContext(null);

export const useAlert = () => {
    const ctx = useContext(AlertContext);
    if (!ctx) {
        throw new Error("useAlert must be used inside AlertProvider");
    }
    return ctx;
};

export default AlertContext;
